import Controller from '@ember/controller';

export default class VisitorsSettingsVisitorTypesFlowFinalScreenController extends Controller {
  isEditingCustomFinalMessage = false;
}
